import { useFetchSchedulesAlerts } from "@/pages/human-resources/time-management/services/hooks/useFetchSchedulesAlerts.ts";
import useScheduleViewStateDispatch from "@/pages/human-resources/time-management/model/schedule-view/useScheduleViewStateDispatch.ts";
import useValidateSchedules from "@/pages/human-resources/time-management/services/hooks/useValidateSchedules.ts";
import useScheduleDataStateDispatch from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useScheduleDataStateDispatch.ts";
import type { EmployeeSchedules } from "@/pages/human-resources/time-management/business/EmployeeSchedules.ts";
import { useWithThreeDotsOverlay } from "@/shared/components/generic/hooks/useWithThreeDotsOverlay.ts";

export default function useValidateOrShowAlerts(): (
  employeesSchedules: EmployeeSchedules[],
) => Promise<void> {
  const fetchAlerts = useFetchSchedulesAlerts();
  const validateSchedules = useValidateSchedules();
  const withThreeDotsOverlay = useWithThreeDotsOverlay();
  const { dispatch: viewStateDispatch } = useScheduleViewStateDispatch();
  const dataStateDispatch = useScheduleDataStateDispatch();

  return async function validateOrShowAlerts(
    employeesSchedules: EmployeeSchedules[],
  ): Promise<void> {
    const empSchedulesWithDraft = employeesSchedules.filter((es) =>
      es.hasModifications(),
    );
    const drafts = empSchedulesWithDraft
      .flatMap((es) => es.getMainSchedules())
      .filter((s) => s.modified);

    try {
      const alerts = await withThreeDotsOverlay(() =>
        fetchAlerts(empSchedulesWithDraft),
      );
      if (alerts === undefined) {
        return;
      }
      if (alerts.isEmpty()) {
        dataStateDispatch({
          type: "employeesMarkStale",
          employeesIds: drafts.map((s) => s.employeeId),
        });
        await validateSchedules.mutateAsync(drafts);
        dataStateDispatch({ type: "schedulesMarkStale" });
      } else {
        viewStateDispatch({
          type: "openAlertsDialog",
          alerts,
          verifiedSchedules: empSchedulesWithDraft,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
}
